import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logo from '../Assets/Kalam Kids Logo_newlogo.png';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { loginUser } from '../api/Api';
import standing from "../Assets/STANDING WITH THUMBS UP.png"
import { AuthContext } from '../utils/AuthContext';

const Login = () => {
  const [username, setusername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // New state to track login status
  const navigate = useNavigate();
  const { updateAuthData } = useContext(AuthContext);

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const data = await loginUser (username, password);
      updateAuthData(data);
      toast.success('Login successful!');
      setIsLoggedIn(true); // Update login status
    } catch (error) {
      console.error('Error signing in:', error.response?.data || error.message);
      toast.error('Invalid credentials. Please try again.');

    }
  };
// ... rest of file ...

  useEffect(() => {
    if (isLoggedIn) {
      console.log('Navigating to /admin/dashboard');
      navigate('/admin/dashboard');   
    }
  }, [isLoggedIn, navigate]);


  return (
    <div className=" h-screen flex flex-col  navbar-link md:flex-row ">
      {/* Logo Section */}
      <div className="flex flex-col justify-center items-center w-full ml-28 md:w-[35%] bg-white ">
        <img src={logo} alt="Logo" className="w-[450px] mb-6" />

        <h1 className="text-3xl font-bold text-[#dbac38] tracking-wide">Welcome Back!</h1>
        <p className="text-gray-600 text-[#16bab1]enter mt-2 px-4">Login to access the admin dashboard</p>
      </div>
<div className='w-[30%] flex items-center justify-center p-5' >
<img src={standing} alt="" className='h-[500px] w-[500px]  object-contain' />
</div>
      {/* Login Form Section */}
      <div className="w-full md:w-[40%] flex items-center justify-center -ml-44 p-5">
        <div className="w-full max-w-md bg-white p-8  ">
          <h2 className="text-[#16bab1]xl font-semibold text-[#16bab1]enter text-gray-800 mb-6">Admin Login</h2>

          <form onSubmit={handleLogin}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email
              </label>
              <input
                type="text"
                id="email"
                value={username}
                onChange={(e) => setusername(e.target.value)}
                placeholder="Enter your email"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-[#e84c24] focus:border-[#16bab1] outline-none"
                required
              />
            </div>
            <div className="mb-6 relative">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                Password
              </label>
              <input
                type={showPassword ? 'text' : 'password'}
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-[#e84c24] focus:border-[#16bab1] outline-none"
                required
                
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-4 top-[38px] text-gray-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            <button
              type="submit"
              className="w-full bg-[#16bab1] hover:bg-[#dbac38] text-white font-semibold py-2 rounded-md transition duration-300"
            >
              Login
            </button>
          </form>
        </div>
      </div>
</div>
  ); 
};

export default Login;
